var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgWaiting = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 7V4H18.5C18.7761 4 19 3.77614 19 3.5V2.5C19 2.22386 18.7761 2 18.5 2H5.5C5.22386 2 5 2.22386 5 2.5V3.5C5 3.77614 5.22386 4 5.5 4H6V7C5.98952 7.92514 6.40649 8.80335 7.13 9.38L10.4 12L7.13 14.62C6.40649 15.1966 5.98952 16.0749 6 17V20H5.5C5.22386 20 5 20.2239 5 20.5V21.5C5 21.7761 5.22386 22 5.5 22H18.5C18.7761 22 19 21.7761 19 21.5V20.5C19 20.2239 18.7761 20 18.5 20H18V17C17.9982 16.0889 17.5825 15.2279 16.87 14.66L13.6 12L16.87 9.38C17.5935 8.80335 18.0105 7.92514 18 7ZM15.62 16.14C15.8819 16.3455 16.0244 16.6679 16 17H8C8.0014 16.6957 8.14126 16.4086 8.38 16.22L12 13.28L15.62 16.14ZM15.62 7.78C15.8587 7.59135 15.9986 7.30427 16 7V4H8V7C7.98888 7.31825 8.13 7.62276 8.38 7.82L9.85 9H14.15L15.62 7.78Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWaiting, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/waiting.f952878a.svg";
export { ForwardRef as ReactComponent };